import BaseImage from '@/components/bases/BaseImage';
import emrTypeHelper from '@/helper/emrType';
import DetailContent from '@/screens/Timeline/components/DetailContent';
import useTimelineStore from '@/screens/Timeline/store';
import useGlobalConfigs from '@/stores/globalConfigs';
import { IQuickModalResult } from '@/utils/quickModal';
import _ from 'lodash';
import * as React from 'react';

export interface IBaseCardEmrProps {
  index: number;
  seeMoreString?: string;
  emr: IEMRData;
}

const BaseCardEmr: React.FC<IBaseCardEmrProps> = ({ index, seeMoreString, emr, ...props }) => {
  const [resultModal, setResultModal] = React.useState<IQuickModalResult>();
  const [, setSeeMore] = React.useState<string>('');
  const getEmrConfig = useGlobalConfigs((s) => s.getEmrType);
  const emrConfig = getEmrConfig(emr.type.code);
  const ref = React.useRef(null);

  const modal = useTimelineStore((s) => s.modal);

  React.useEffect(() => {
    const container: any = ref.current;
    if (container && container.scrollHeight > container.clientHeight) {
      setSeeMore(seeMoreString || ' ');
    }
  }, [seeMoreString]);

  const { cardColor = '#eee', icon, generate } = emrConfig?.extra?.timeline || {};

  const content = generate ? generate(emr, emrConfig) : emrTypeHelper.generateContent(emr, emrConfig as IEMRType);

  return (
    <>
      <div
        className="flex cursor-pointer p-2 hover:bg-mint-1 hover:shadow"
        onDoubleClick={() => {
          console.log('EMR_DATA: ', emr);
          console.log('EMR_CONFIG: ', emrConfig);
        }}
        onClick={() => {
          if (resultModal?.open) {
            resultModal.open();
          } else {
            const result = modal?.custom({
              minimizeContainer: document.querySelector('.minimize-bar'),
              mask: false,
              title: emrConfig?.name,
              width: 900,
              content: <DetailContent emr={emr} emrType={emrConfig as IEMRType} />,
            });
            setResultModal(result);
          }
        }}
      >
        <div className="pt-[1.5px]">
          <div
            className="rounded-full flex-grow wh-[16px] flex items-center justify-center"
            style={{ background: cardColor || '#eee' }}
          >
            <BaseImage src={icon || ''} className="text-white w-full" empty />
          </div>
        </div>

        <div className="px-2 flex flex-col relative w-full" ref={ref}>
          <div className="text-[15px] font-semibold mb-2 flex items-center border-b pb-1">
            {_.get(emrConfig, 'name')}
          </div>

          <div className="relative">
            <div className="absolute left-[-15px] top-0 h-full border-l"></div>
            <div
              className="whitespace-pre-wrap relative text-[13px] text-clip line-clamp-3"
              dangerouslySetInnerHTML={{ __html: content }}
            ></div>
          </div>
        </div>
      </div>
    </>
  );
};
export default BaseCardEmr;
